import { apiSlice } from "../apiSlice";

interface CreateNewsLetterRequest {
 
  email: string;
}
interface CreateNewsLetterResponse {
  success: boolean;
  message: string;
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const NewsLetterService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createNewsLetter: builder.mutation<
      CreateNewsLetterResponse,
      CreateNewsLetterRequest
    >({
      query: (data) => ({
        url: `https://customerhttps-createnewslettersubscription-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});
export const { useCreateNewsLetterMutation } = NewsLetterService;
